<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-payOrder__payorder}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.userId" placeholder="用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.orderCode" placeholder="平台订单号" clearable></el-input>
        </el-form-item>
         <el-form-item>
          <el-input v-model="dataForm.trilateralCode" placeholder="第三方订单号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.orderType" placeholder="支付状态" clearable filterable >
            <el-option
                v-for="item in orderTypeArray"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.actualMerchantType" placeholder="实际支付通道" clearable filterable>
            <el-option
                v-for="item in merchantTypeArray"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.peyType" placeholder="支付类型" clearable filterable>
            <el-option
                v-for="item in peyTypeArray"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        
        <el-form-item>
          <el-button v-if="$hasPermission('payOrder:payorder:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('payOrder:payorder:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-popover
            placement="bottom"
            width="300"
            trigger="click"
            v-model="columnFilterVisible"> 
            <div class="column-filter-panel">
              <div class="filter-header">
                <span>列显示设置</span>
                <el-button type="text" size="small" @click="resetColumns">重置</el-button>
              </div>
              <el-checkbox-group v-model="selectedColumns" class="filter-checkboxes">
                <el-checkbox
                  v-for="col in allColumns"
                  :key="col.prop"
                  :label="col.prop"
                  :disabled="col.required">
                  {{ col.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <el-button slot="reference" icon="el-icon-setting">列筛选</el-button>
          </el-popover>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" :row-class-name="tableRowClassName" style="width: 100%;" :fit="true">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column fixed="left"  v-if="isColumnVisible('userId')" prop="userId" label="用户ID" min-width="100" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('commodityType')" prop="commodityType" label="商品类型" min-width="110" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.commodityType === 1">钻石</el-tag>
            <el-tag v-if="scope.row.commodityType === 2" size="success" type="success">VIP</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('commoditySpecification')" prop="commoditySpecification" min-width="130" label="商品规格" header-align="center" align="center"></el-table-column>

        <el-table-column v-if="isColumnVisible('orderCode')" prop="orderCode" label="平台订单号" min-width="200" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('trilateralCode')" prop="trilateralCode" label="第三方订单号" min-width="200" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('merchantType')" prop="merchantType" label="支付通道" min-width="110" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag :type="getMerchantTagType(scope.row.merchantType)">
              {{ getMerchantName(scope.row.merchantType) }}
            </el-tag>
          </template>
        </el-table-column>
         <el-table-column v-if="isColumnVisible('actualMerchantType')" prop="actualMerchantType" label="实际支付通道" min-width="110" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag :type="getMerchantTagType(scope.row.actualMerchantType)">
              {{ getMerchantName(scope.row.actualMerchantType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('rechargeAmount')" prop="rechargeAmount" label="充值金额" min-width="110" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('peyType')" prop="peyType" label="支付类型" min-width="120" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag :type="getPeyTypeTagType(scope.row.peyType)">
              {{ getPeyTypeName(scope.row.peyType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('orderType')" prop="orderType" label="支付状态" min-width="150" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag :type="getOrderTypeTagType(scope.row.orderType)">
              {{ getOrderTypeName(scope.row.orderType) }}
            </el-tag>
          </template>
        </el-table-column>
         <el-table-column v-if="isColumnVisible('peyStatus')" prop="peyStatus" label="设备类型" :show-overflow-tooltip="true" min-width="130" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.peyStatus === 1" size="success" type="success">PC Web</el-tag>
            <el-tag v-if="scope.row.peyStatus === 2" size="success" type="info">移动Web</el-tag>
            <el-tag v-if="scope.row.peyStatus === 3" size="success" type="danger">Android APP</el-tag>
            <el-tag v-if="scope.row.peyStatus === 4" size="success" type="danger">iOS APP</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('payUrl')" prop="payUrl" label="支付链接" min-width="250" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div class="pay-url-cell">
              <span class="pay-url-text" :title="scope.row.payUrl">{{ scope.row.payUrl }}</span>
              <el-button
                v-if="scope.row.payUrl"
                type="text"
                size="mini"
                icon="el-icon-document-copy"
                @click="copyPayUrl(scope.row.payUrl)"
                class="copy-btn">
                复制
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('cryptoTxId')" prop="cryptoTxId" label="数字货币交易地址" min-width="250" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div class="pay-url-cell">
              <span class="pay-url-text" :title="scope.row.cryptoTxId">{{ scope.row.cryptoTxId }}</span>
              <el-button
                v-if="scope.row.cryptoTxId"
                type="text"
                size="mini"
                icon="el-icon-document-copy"
                @click="copyPayUrl(scope.row.cryptoTxId)"
                class="copy-btn">
                复制
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('foundTime')" prop="foundTime" label="订单创建时间" min-width="180" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('address')" prop="address" label="IP地址" min-width="140" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('sourceUrl')" prop="sourceUrl" label="来源域名" min-width="180" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="isColumnVisible('promotionSource')" prop="promotionSource" label="渠道" min-width="180" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="isColumnVisible('vpnRiskLevel')" prop="vpnRiskLevel" label="VPN风险级别" min-width="130" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('channelSwitchCount')" prop="channelSwitchCount" label="通道调用次数" min-width="140" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- = 0：未调用（灰色文本） -->
            <span v-if="scope.row.channelSwitchCount === 0" style="color: #909399;">未调用</span>
            <!-- = 1：只调用1次（绿色标签） -->
            <el-tag v-else-if="scope.row.channelSwitchCount === 1" type="success">1次(正常)</el-tag>
            <!-- > 1：切换了（橙色标签，可点击） -->
            <el-tag v-else type="warning" style="cursor: pointer;" @click="viewChannelSwitchHistoryDialog(scope.row)">
              {{ scope.row.channelSwitchCount }}次(已切换)
            </el-tag>
          </template>
        </el-table-column>
        <!-- 操作列（固定在右侧） -->
        <el-table-column label="操作" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" icon="el-icon-view" @click="viewChannelSwitchHistoryDialog(scope.row)">查看</el-button>
            <el-button type="text" size="small" icon="el-icon-link" @click="viewChannelSwitchHistory(scope.row)">跳转</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="total-amount-info">
        <span class="label">总计金额:</span>
        <span class="amount">{{ totalAmount }}</span>
        <span class="unit">元</span>
        <span class="separator">|</span>
        <span class="label">当前页总计金额:</span>
        <span class="amount">{{ currentPageTotal }}</span>
        <span class="unit">元</span>
        <span class="separator">|</span>
        <span class="count-label">订单数:</span>
        <span class="count">{{ dataList.length }}</span>
        <span class="unit">笔</span>
      </div>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>

      <!-- 通道切换历史弹窗 -->
      <el-dialog
        title="通道切换历史"
        :visible.sync="channelHistoryDialogVisible"
        width="1000px"
        :close-on-click-modal="false"
        @closed="channelHistoryList = []">
        <div slot="title" style="font-size: 16px;">
          <i class="el-icon-document"></i>
          订单 <strong style="color: #409EFF;">{{ currentOrderCode }}</strong> 的通道切换历史
        </div>

        <el-table
          v-loading="channelHistoryLoading"
          :data="channelHistoryList"
          border
          size="small"
          max-height="500"
          :empty-text="channelHistoryList.length === 0 && !channelHistoryLoading ? '该订单暂无通道切换记录\n订单可能尚未调用支付通道，或首次调用即成功' : '暂无数据'"
          style="width: 100%;">
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="attemptOrder" label="尝试顺序" width="100" align="center">
            <template slot-scope="scope">
              第{{ scope.row.attemptOrder }}次
            </template>
          </el-table-column>
          <el-table-column prop="merchantTypeName" label="商户类型" width="120" align="center"></el-table-column>
          <el-table-column prop="peyTypeName" label="支付类型" width="100" align="center"></el-table-column>
          <el-table-column prop="isSuccess" label="成功状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isSuccess === 1 ? 'success' : 'danger'" size="small">
                {{ scope.row.successText }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="responseTime" label="响应时间" width="100" align="center">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.responseTime > 2000 ? '#F56C6C' : '' }">
                {{ scope.row.responseTime }}ms
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="160" align="center"></el-table-column>
          <el-table-column prop="responseData" label="响应数据" min-width="200">
            <template slot-scope="scope">
              <el-tooltip placement="top" effect="light" :content="scope.row.responseData">
                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ scope.row.responseData }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <div slot="footer">
          <el-button @click="channelHistoryDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import dateTimeRangeMixin from '@/mixins/datetime-range'
import AddOrUpdate from './payorder-add-or-update'
export default {
  mixins: [mixinViewModule, dateTimeRangeMixin],
  data () {
    return {
      orderTypeArray:[
        {
          value: '0',
          label: '订单创建'
        },{
          value: '1',
          label: '支付成功'
        },{
          value: '2',
          label: '支付失败'
        },{
          value: '3',
          label: '订单超时'
        },{
          value: '4',
          label: '第三方调用失败或超时'
        }
      ],
      merchantTypeArray: [],
      peyTypeArray: [],
      payStatusesArray: [],
      merchantNameMap: new Map(),  // 商户类型名称映射表（后端提供）
      peyTypeNameMap: new Map(),   // 支付类型名称映射表（后端提供）
      orderTypeMap: new Map(),   // 支付类型名称映射表（后端提供）
      mixinViewModuleOptions: {
        getDataListURL: '/payOrder/payorder/page',
        getDataListIsPage: true,
        exportURL: '/payOrder/payorder/export',
        deleteURL: '/payOrder/payorder',
        deleteIsBatch: true
      },
      dateRange: null,
      dataForm: {
        id: '',
        orderType: '',
        orderCode: '',
        trilateralCode: '',
        actualMerchantType: '',
        peyType: ''
      },
      // 列筛选相关
      columnFilterVisible: false,
      
      allColumns: [
        { prop: 'userId', label: '用户ID', required: false },
        { prop: 'commodityType', label: '商品类型', required: false },
        { prop: 'commoditySpecification', label: '商品规格', required: false },
        { prop: 'orderCode', label: '平台订单号', required: false },
        { prop: 'trilateralCode', label: '第三方订单号', required: false },
        { prop: 'merchantType', label: '支付通道', required: false },
        { prop: 'actualMerchantType', label: '实际支付通道', required: false },
        { prop: 'rechargeAmount', label: '充值金额', required: false },
        { prop: 'peyType', label: '支付类型', required: false },
        { prop: 'orderType', label: '支付状态', required: false },
        { prop: 'peyStatus', label: '设备类型', required: false },
        { prop: 'payUrl', label: '支付链接', required: false },
        { prop: 'cryptoTxId', label: '数字货币交易地址', required: false },
        { prop: 'foundTime', label: '订单创建时间', required: false },
        { prop: 'address', label: 'IP地址', required: false },
        { prop: 'sourceUrl', label: '来源域名', required: false },
        { prop: 'promotionSource', label: '渠道', required: false },
        { prop: 'vpnRiskLevel', label: 'VPN风险级别', required: false },
        { prop: 'channelSwitchCount', label: '通道切换次数', required: false }
      ],
      selectedColumns: [],

      // 通道切换历史弹窗
      channelHistoryDialogVisible: false,
      channelHistoryLoading: false,
      currentOrderCode: '',
      channelHistoryList: [],

      // 总充值金额（后端返回）
      totalRechargeAmount: 0
    }
  },

  created() {
    // 初始化选中的列 (默认全选)
    this.initSelectedColumns()
    // 获取支付平台配置
    this.getPaymentPlatforms()
  },
  components: {
    AddOrUpdate
  },

  computed: {
    // 总充值金额（使用后端返回的值）
    totalAmount() {
      return (this.totalRechargeAmount || 0).toFixed(2)
    },
    // 当前页金额总和
    currentPageTotal() {
      if (!this.dataList || this.dataList.length === 0) {
        return '0.00'
      }
      const total = this.dataList.reduce((sum, item) => {
        return sum + (parseFloat(item.rechargeAmount) || 0)
      }, 0)
      return total.toFixed(2)
    }
  },

  watch: {
    'dateRange'(val) {
      if (!val || val.length === 0) {
        this.dataForm.startDate = null
        this.dataForm.endDate = null
      } else {
        // datetimerange 已经包含完整的日期时间,直接赋值
        this.dataForm.startDate = val[0]
        this.dataForm.endDate = val[1]
      }
      console.log('======>'+JSON.stringify(this.dataForm));
    },
    // 监听列选择变化,自动保存
    selectedColumns: {
      handler() {
        this.saveColumnSettings()
      },
      deep: true
    }
  },

  methods: {
    // 覆盖 mixin 的 query 方法以适配新的接口数据结构
    query() {
      this.dataListLoading = true
      this.$http.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          params: {
            order: this.order,
            orderField: this.orderField,
            page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
            limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
            ...this.dataForm
          }
        }
      ).then(({ data: res }) => {
        this.dataListLoading = false
        if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          this.totalRechargeAmount = 0
          return this.$message.error(res.msg)
        }
        // 适配新的数据结构：data.pageData.list 和 data.pageData.total
        this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? res.data.pageData.list : res.data
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? res.data.pageData.total : 0
        // 获取总充值金额
        this.totalRechargeAmount = res.data.totalRechargeAmount || 0
      }).catch(() => {
        this.dataListLoading = false
        this.dataList = []
        this.total = 0
        this.totalRechargeAmount = 0
      })
    },

    // 获取支付平台配置
    getPaymentPlatforms() {
      this.$http.get('/payOrder/payorder/paymentPlatforms').then(({ data: res }) => {
        if (res.code !== 0) {
          console.error('获取支付平台配置失败:', res.msg)
          return
        }

        // 处理商户类型数据（后端已返回中文名称，无需前端映射）
        if (res.data.merchantTypes && res.data.merchantTypes.length > 0) {
          this.merchantTypeArray = res.data.merchantTypes.map(item => ({
            value: item.merchantType,      // JC_PAY, MS_PAY 等
            label: item.merchantsName       // 金诚通, 铭森 等（后端返回）
          }))

          // 创建商户类型名称映射表，用于表格显示
          this.merchantNameMap = new Map(
            res.data.merchantTypes.map(item => [item.merchantType, item.merchantsName])
          )
        }

         if (res.data.payStatuses && res.data.payStatuses.length > 0) {
          this.payStatusesArray = res.data.payStatuses.map(item => ({
            value: item.statusCode,      // JC_PAY, MS_PAY 等
            label: item.statusName       // 金诚通, 铭森 等（后端返回）
          }))

          // 创建商户类型名称映射表，用于表格显示
          this.orderTypeMap = new Map(
            res.data.payStatuses.map(item => [item.statusCode, item.statusName])
          )
        }
        // 处理支付类型数据（后端已返回中文名称，无需前端映射）
        if (res.data.peyTypes && res.data.peyTypes.length > 0) {
          this.peyTypeArray = res.data.peyTypes.map(item => ({
            value: item.peyType,           // 2, 3 等
            label: item.peyTypeName        // 微信支付, 支付宝支付（后端返回）
          }))

          // 创建支付类型名称映射表，用于表格显示
          this.peyTypeNameMap = new Map(
            res.data.peyTypes.map(item => [item.peyType, item.peyTypeName])
          )
        }
      }).catch((error) => {
        console.error('获取支付平台配置异常:', error)
      })
    },

    // 获取商户名称（从映射表中获取，后端已提供）
    getMerchantName(merchantType) {
      return this.merchantNameMap.get(merchantType) || merchantType
    },

    // 获取支付类型名称（从映射表中获取，后端已提供）
    getPeyTypeName(peyType) {
      return this.peyTypeNameMap.get(Number(peyType)) || `未知类型(${peyType})`
    },
     getOrderTypeName(orderType) {
      return this.orderTypeMap.get(Number(orderType)) || `未知类型(${orderType})`
    },
    // 商户类型标签颜色映射
    getMerchantTagType(merchantType) {
      const typeMap = {
        'JC_PAY': 'warning',
        'YA_PAY': 'primary',
        'SA_PAY': 'success',
        'MS_PAY': 'success',
        'SS_PAY': 'info',
        'WN_PAY': 'danger'
      }
      return typeMap[merchantType] || ''
    },

    // 支付类型标签颜色映射
    getPeyTypeTagType(peyType) {
      const typeMap = {
        2: 'success',
        3: 'primary'
      }
      return typeMap[peyType] || ''
    },

    // 获取支付状态名称
    // getOrderTypeName(orderType) {
    //   const typeMap = {
    //     0: '订单创建',
    //     1: '支付成功',
    //     2: '支付失败',
    //     3: '订单超时',
    //     4: '第三方调用失败或超时'
    //   }
    //   return typeMap[orderType] || `未知状态(${orderType})`
    // },

    // 支付状态标签颜色映射
    getOrderTypeTagType(orderType) {
      const typeMap = {
        0: 'warning',   // 订单创建 - 橙色
        1: 'success',   // 支付成功 - 绿色
        2: 'info',      // 支付失败 - 蓝灰色
        3: 'danger',    // 订单超时 - 红色
        4: 'danger'  ,   // 第三方调用失败或超时 - 红色
        5: 'info'     // 第三方调用失败或超时 - 红色
      }
      return typeMap[orderType] || ''
    },

    // 查看通道切换历史（跳转到独立页面）
    viewChannelSwitchHistory(row) {
      // 跳转到通道切换历史页面，并传递订单号作为查询参数
      this.$router.push({
        path: '/channelSwitchHistory-channelswitchhistory',
        query: {
          orderCode: row.orderCode
        }
      })
    },

    // 查看通道切换历史（弹窗展示）
    viewChannelSwitchHistoryDialog(row) {
      this.currentOrderCode = row.orderCode
      this.channelHistoryDialogVisible = true
      this.channelHistoryLoading = true
      this.channelHistoryList = []

      // 调用接口查询该订单的通道切换历史
      this.$http.get(`/payOrder/channelSwitchHistory/listByOrderCode/${row.orderCode}`).then(({ data: res }) => {
        if (res.code !== 0) {
          this.$message.error(res.msg || '查询失败')
          return
        }
        this.channelHistoryList = res.data || []
      }).catch(error => {
        console.error('查询通道切换历史失败:', error)
        this.$message.error('查询失败，请稍后重试')
      }).finally(() => {
        this.channelHistoryLoading = false
      })
    },

    // 表格行样式（通道切换订单黄色高亮）
    // 注意：当 channelSwitchCount > 1 时才高亮（表示发生过通道切换）
    // = 0：未调用（正常），= 1：只调用1次（正常），> 1：切换了（异常）
    tableRowClassName({ row }) {
      if (row.channelSwitchCount > 1) {
        return 'channel-switch-highlight-row'
      }
      return ''
    },

    initSelectedColumns() {
      const savedColumns = localStorage.getItem('payorder_selected_columns')
      if (savedColumns) {
        const saved = JSON.parse(savedColumns)
        // 获取所有列的prop
        const allProps = this.allColumns.map(col => col.prop)
        // 找出新增的列(在allColumns中存在但在saved中不存在的)
        const newColumns = allProps.filter(prop => !saved.includes(prop))
        // 合并保存的列和新增的列
        this.selectedColumns = [...saved, ...newColumns]
        // 更新localStorage
        if (newColumns.length > 0) {
          this.saveColumnSettings()
        }
      } else {
        // 默认全选
        this.selectedColumns = this.allColumns.map(col => col.prop)
      }
    },

    // 判断列是否可见
    isColumnVisible(prop) {
      return this.selectedColumns.includes(prop)
    },

    resetColumns() {
      this.selectedColumns = this.allColumns.map(col => col.prop)
      this.saveColumnSettings()
      this.$message.success('已重置列显示设置')
    },

    saveColumnSettings() {
      localStorage.setItem('payorder_selected_columns', JSON.stringify(this.selectedColumns))
    },

    // 复制支付链接
    copyPayUrl(url) {
      if (!url) {
        this.$message.warning('支付链接为空')
        return
      }

      const input = document.createElement('input')
      input.value = url
      document.body.appendChild(input)
      input.select()

      try {
        document.execCommand('copy')
        this.$message.success('支付链接已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败,请手动复制')
        console.error('复制错误:', err)
      }

      document.body.removeChild(input)
    }
  }
}
</script>
<style scoped>
/* 通道切换订单行高亮样式 */
.el-table >>> .channel-switch-highlight-row {
  background-color: #fffbe6 !important;
}

.el-table >>> .channel-switch-highlight-row:hover > td {
  background-color: #fff7e6 !important;
}

.total-amount-info {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #606266;
  margin-top: 15px;
  margin-bottom: 10px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.total-amount-info .label,
.total-amount-info .count-label {
  font-weight: 500;
  margin-right: 5px;
  color: #303133;
}

.total-amount-info .amount {
  font-size: 20px;
  font-weight: bold;
  color: #F56C6C;
  margin-right: 3px;
}

.total-amount-info .count {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  margin-right: 3px;
}

.total-amount-info .unit {
  font-size: 13px;
  color: #606266;
  margin-right: 15px;
}

.total-amount-info .separator {
  color: #909399;
  margin: 0 15px;
  font-weight: bold;
}

/* 支付链接单元格样式 */
.pay-url-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.pay-url-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: #606266;
  min-width: 0;
}

.copy-btn {
  flex-shrink: 0;
  padding: 0 5px;
  margin-left: 5px;
}

.copy-btn:hover {
  color: #409EFF;
}

/* 列筛选面板样式 */
.column-filter-panel {
  padding: 10px 0;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 10px;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 10px;
}

.filter-header span {
  font-weight: 500;
  font-size: 14px;
  color: #303133;
}

.filter-checkboxes {
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;
  padding: 0 10px;
}

.filter-checkboxes .el-checkbox {
  margin: 8px 0;
  line-height: 1.5;
}

.filter-checkboxes .el-checkbox.is-disabled .el-checkbox__label {
  color: #C0C4CC;
}
</style>
